export enum FilterIncompatibilityEnum {
  ChannelNotActivePreOrder = 1,
}
